import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_account_entitlement_auto_top_up_template_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_claim_account_entitlement_auto_top_up_template_RowClass implements
  bl_aat_claim_account_entitlement_auto_top_up_template_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  entitlement_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
